import { render } from "./AddMyIndividual.vue?vue&type=template&id=4e173ac6"
import script from "./AddMyIndividual.vue?vue&type=script&lang=js"
export * from "./AddMyIndividual.vue?vue&type=script&lang=js"

import exportComponent from "P:\\htdocs\\we-smile\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__